import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

export const SETTINGS = [["fuel_price", "Precio del gasoil ($ por litro)"], ["usd_rate", "Cotización del dólar ($)"], ["default_l100", "Consumo por defecto (l/100 km)"],
  ["driver_salary", "Sueldo del chofer por viaje ($)"], ["tire_cost", "Costo de una cubierta ($)"], ["tire_life_km", "Vida útil de una cubierta (km)"],
  ["maintenance_monthly", "Reserva de mantenimiento mensual ($)"], ["monthly_km", "Km que hace una unidad por mes"], ["margin_pct", "Ganancia (%)"], ["quote_valid_days", "Validez del presupuesto (días)"]];

export const CostSettings = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/fleet/settings").then((r) => setF(r.data)).catch(() => setF({})); }, []);
  if (!f) return null;
  const save = async () => {
    try { const { data } = await api.put("/fleet/settings", Object.fromEntries(Object.entries(f).map(([k, v]) => [k, Number(v || 0)]))); setF(data); toast.success("Valores guardados"); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="cost-settings" className="max-w-3xl space-y-3 rounded-2xl bg-white p-5 ring-1 ring-black/5">
      <p className="text-sm text-[var(--muted-ink)]">Valores que usa cada presupuesto de cargas y turismo (se pueden cambiar en cada viaje). Los costos mensuales (mantenimiento, seguro y cuotas) se reparten por kilómetro según los km que hace una unidad por mes. Todo es antes de impuestos.</p>
      <div className="grid gap-3 sm:grid-cols-3">
        {SETTINGS.map(([k, l]) => (
          <label key={k} className="text-xs text-[var(--muted-ink)]">{l}<input data-testid={`setting-${k}`} type="number" value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-10 w-full rounded-xl border border-black/10 px-3 text-sm text-[var(--ink)]" /></label>
        ))}
      </div>
      <button onClick={save} data-testid="settings-save" className="h-11 rounded-xl bg-[var(--forest)] px-6 text-sm font-bold text-white">Guardar valores</button>
    </div>
  );
};
